<template>
<div>
<button v-on-clickaway="away" class="w-full border border-black  bg-white py-2 focus:outline-none">
        <div @click="populateOptions($event)" >
        <a ref="input" class="w-full h-full ml-8 text-lg leading-tight font-semibold hover:border-green-600"> {{subCatSelected.name}}
   <i class="fas fa fa-caret-down float-right mr-5 mt-1"></i>
        </a>
  </div>
      <div class="sm:w-full">
        <div v-bind:key="option.id" v-for="(option,$index) in dropdownSubCatOptions">
          <a href="#" v-if="option.name != subCatSelected.name || dropdownSubCatOptions.length == 1"  @click="setSub(option,$event,$index)" class="z-40 mt-1 block text-lg leading-tight font-semibold hover:font-bold  hover:border-black">
            {{option.name}}
          </a>
        </div>
      </div>

</button>
      </div>

</template>
<script>
import {
  mapState, mapGetters, mapMutations, mapActions,
} from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import _ from 'lodash';

export default {
  head() {
    return {
      title: {
        inner: 'Home',
      },
      meta: [
        {
          name: 'description',
          content: `${this.appTitle} home page`,
          id: 'desc',
        },
      ],
    };
  },
  mixins: [clickaway],
  computed: {
    ...mapState('app', ['appTitle']),
    ...mapState('search', ['dropdownMainSelected', 'mainOptions', 'dropdownIndex', 'subCatSelected', 'teststate', 'SelectedOption']),
    ...mapGetters('search', ['getDropdown', 'getSelectedOption']),
    dropdownSelect: {
      get() {
        console.log(this.SelectedOption);
        return this.SelectedOption;
      },
      set(value) {
        console.log(value);
        this.setDropdownMainCatIndex({ index: value });
      },
    },
  },
  data() {
    return {
      dropdownSubCatOptions: [],
    };
  },
  methods: {
    ...mapMutations('search', ['setDropdownOption', 'SetSubCatagoryDirectly', 'setDropdownSubCatIndex', 'setSubCatDropdownSelected']),
    ...mapActions('search', ['getMainOptions', 'getTestKitProducts']),

    populateOptions(event) {
      console.log(this.$refs.input);
      // `this` inside methods point to the Vue instance
      // `event` is the native DOM event
      event.preventDefault();
      this.openBox = true;
      // selectedIndex =
      this.dropdownSubCatOptions = _.cloneDeep(this.mainOptions[this.dropdownIndex].options[0]);
      console.log(this.dropdownSubCatOptions);
      // this.dropdownSubCatOptions = _.remove
      // _.remove(this.dropdownSubCatOptions,this.selected)

      this.dropdownSubCatOptions.splice();
    },
    setSub(selected, event, index) {
      console.log(index);
      event.preventDefault();
      this.setSubCatDropdownSelected(selected.name);
      this.setDropdownSubCatIndex(index);
      this.dropdownSubCatOptions = [];
      this.openBox = false;
    },
    search(name, event) {
      event.preventDefault();
    },
    away() {
      this.dropdownSubCatOptions = [];
    },
  },
};
</script>
